import type { HelpWidgetConversation } from "@/react/components/HelpWidget/types/help_widget_conversation";
import { absolutePath } from "./absolutePath";

interface HelpWidgetFnProps {
  attachmentId?: string | number;
  chat_bot_session_id?: string;
  conversation?: HelpWidgetConversation;
  conversationFilters?: {
    channel_type: "all" | "circle_bot" | "live_chat" | "email";
    status: "all" | "draft" | "closed" | "solved" | "open";
  };
  conversationId?: string | number;
  flow?: Record<string, unknown>;
  id?: string | number;
  messageId?: string | number;
  params?: Record<string, unknown>;
  searchText?: string | number;
  source?: string;
  spaceId?: string | number;
  submit_page_url?: string;
  target?: string;
  viewport_height?: string;
  viewport_width?: string;
}

export const helpWidget = {
  listConversations: ({ conversationFilters }: HelpWidgetFnProps) =>
    absolutePath("help_widget/conversations", {
      conversation: conversationFilters,
    }),
  showConversation: ({ id }: HelpWidgetFnProps) =>
    absolutePath(`help_widget/conversations/${id}`),
  createEmailConversation: ({ conversation }: HelpWidgetFnProps) =>
    absolutePath("help_widget/conversations", { conversation }),
  updateConversation: ({ id, conversation }: HelpWidgetFnProps) =>
    absolutePath(`help_widget/conversations/${id}`, { conversation }),
  createChat: () => absolutePath("help_widget/chats"),
  createChatMessage: ({ id }: { id: string }) =>
    absolutePath(`help_widget/conversations/${id}/messages`),
  submitConversation: ({ id }: HelpWidgetFnProps) =>
    absolutePath(`help_widget/conversations/${id}/submit_conversation`),
  createAttachment: ({ conversationId }: HelpWidgetFnProps) =>
    absolutePath(`help_widget/conversations/${conversationId}/attachments`),
  deleteAttachment: ({ conversationId, attachmentId }: HelpWidgetFnProps) =>
    absolutePath(
      `help_widget/conversations/${conversationId}/attachments/${attachmentId}`,
    ),
  getAttachments: ({ conversationId, params }: HelpWidgetFnProps) =>
    absolutePath(
      `help_widget/conversations/${conversationId}/attachments`,
      params,
    ),
  clickButton: ({ conversationId, messageId }: HelpWidgetFnProps) =>
    absolutePath(
      `help_widget/conversations/${conversationId}/messages/${messageId}/click`,
    ),
};
